import groq from 'groq';
import { portableTextWithReferences } from '@pkg/sanity-utils/portableTextWithReferences';

export const portableEditorFields = groq`
  ...,
  content[] {
    ${portableTextWithReferences}
  }
`;
